var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelayed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8669",
    "data-name": "Rectangle 8669",
    width: 10.232,
    height: 10.223,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Delayed"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delayed",
    clipPath: "url(#clip-Delayed)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_624",
    "data-name": "Ellipse 624",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(1.051 1)",
    fill: "#db2626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10866",
    "data-name": "Group 10866",
    transform: "translate(5.051 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10752",
    "data-name": "Group 10752",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20167",
    "data-name": "Path 20167",
    d: "M10.233,5.542c-.062.311-.105.627-.189.932A5.106,5.106,0,1,1,10.2,4.553a1.191,1.191,0,0,0,.033.142Zm-5.9-1.325c0,.417,0,.835,0,1.252a.622.622,0,0,0,.257.523c.568.44,1.134.883,1.7,1.321a.59.59,0,1,0,.722-.929c-.459-.36-.924-.713-1.378-1.079a.353.353,0,0,1-.117-.239C5.5,4.379,5.51,3.691,5.508,3a.592.592,0,1,0-1.18,0c0,.405,0,.81,0,1.215",
    transform: "translate(-0.001 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelayed);
export default __webpack_public_path__ + "static/media/Delayed.c3144ff4c7b9be8213757a9ec02a5249.svg";
export { ForwardRef as ReactComponent };